import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { WhiteBlock } from '~/shared/ui/Wrappers'

export const Wrapper = styled(WhiteBlock)`
  box-shadow: none;
  background: ${myPalette.midnightBlue['100']};
`

export const SubTitle = styled.div`
  color: ${myPalette.dark.main};
  font-size: 12px;
  margin-bottom: 4px;
`

export const Title = styled.div`
  color: ${myPalette.midnightBlue.main};
  font-size: 16px;
  font-weight: 500;
  position: relative;
  width: 100%;
  color: ${myPalette.white.main};
`
